'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fasl';
var iconName = 'umbrella-beach';
var width = 576;
var height = 512;
var aliases = [127958];
var unicode = 'f5ca';
var svgPathData = 'M571.1 285.5c-1 10.7-2.8 21.4-5.2 32.2l-30.3-11-92.8-33.8s0 0 0 0l-30.1-10.9L245 200.9l-30.1-10.9s0 0 0 0l-96.1-35-30.3-11c5-9.8 10.6-19.1 16.7-28c63.7-92.9 183.7-135.4 294.7-97c.9 .3 1.7 .6 2.6 .9l5.9 2.1c2.5 .9 5 1.9 7.4 3c104.8 44.1 166 151.1 155.3 260.5zM389.6 49.2c-24.1-7.9-50.7-1.3-68.3 17.3c-28.5 30.1-50.7 65.6-65.3 104.3l167.6 61c13.7-39.1 19.5-80.5 17-121.9c-1.4-24.2-16-45.5-37.7-55.6c-3.3-1.4-6.6-2.7-10-3.9c-1.1-.4-2.2-.8-3.2-1.2zM305.9 37c-66.7 3.1-129.4 36.1-169.6 90.2l89.6 32.6C242 117 266.5 77.8 298 44.5c2.5-2.7 5.1-5.1 7.9-7.5zM453.6 242.7l86.3 31.4c3.9-65.7-21.5-129.6-68.3-174.7c.4 2.8 .7 5.7 .9 8.5c2.7 45.7-3.7 91.6-18.9 134.8zM16 480l203.4 0 81.8-224.7 30.1 10.9L253.4 480 560 480l16 0 0 32-16 0L16 512 0 512l0-32 16 0z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faUmbrellaBeach = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;